import React, { useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Share from '../components/Share'
import SideOverlap from './sideOverlap'
import UniversityApplicationForm from '../components/ApplicationForm/University'
import { useLocation } from 'react-router-dom'
  

export default function UniversityApplication() {
        const location = useLocation()
          console.log(location)
              useEffect(() => {
                const handleBeforeUnload = (e) => {
                  // Match pattern: /school/:id/SchoolApplicationForm
                  const isSchoolFormRoute = /^\/school\/[^/]+\/SchoolApplicationForm$/.test(location.pathname);
                  const isExtraRoute = location.pathname == "/universityapplication";
                  console.log(isExtraRoute)
                  console.log(isSchoolFormRoute)
            
                  if (isSchoolFormRoute || isExtraRoute) {
                    e.preventDefault();
                    e.returnValue = ""; // Required for Chrome/Edge to show confirmation
                  }
                };
            
                window.addEventListener("beforeunload", handleBeforeUnload);
            
                return () => {
                  window.removeEventListener("beforeunload", handleBeforeUnload);
                };
              }, [location.pathname]);

    return (
        <>
            <Header />
            <UniversityApplicationForm />
            <Share />
            <Footer />
            <SideOverlap />
        </>
    )
}
